import { registerLocaleData } from '@angular/common';
import vi from '@angular/common/locales/vi';
import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { en_US, NzI18nService, vi_VN, zh_CN, zh_TW } from 'ng-zorro-antd/i18n';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { MatomoTracker } from 'ngx-matomo';
import { delay, interval, Subscription } from 'rxjs';
import { LayoutComponent } from 'src/app/layout/layout.component';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { URLConst } from 'src/app/shared/const/url.const';
import { AppConfigService } from 'src/app/shared/service/app-config.service';
import { EnvironmentconfigService } from 'src/app/shared/service/environmentconfig.service';
import { I18nService } from 'src/app/shared/service/i18n.service';
import { WebApiService } from '../../../shared/service/webapi.service';
import { JsFndaUser, JsFndaUserGroup } from '../../models/layout-model';
import { GetTitleService } from './../../../shared/service/get-title.service';
import { AccountInfoComponent } from './account-info/account-info.component';
import { HelpInfoComponent } from './help-info/help-info.component';
import { SwitchDialogComponent } from '../switch-dialog/switch-dialog.component';
import { TResult } from 'src/app/shared/models/common-models';
import { SwitchIdentityComponent } from '../switch-identity/switch-identity.component';
interface MenuItem {
  title: string;
  url: string;
  children?: MenuItem[];
}

interface BreadcrumbItem {
  deep: number,
  label: string,
  url: string,
}
interface MyRoute {
  firstChild?: MyRoute | null;
  outlet: string;
  // 其他属性...
}

@Component({
  selector: 'app-top-navbar',
  templateUrl: './top-navbar.component.html',
  styleUrls: ['./top-navbar.component.scss'],
  providers: []
})
export class TopNavbarComponent implements OnInit, OnDestroy {


  userInfo: JsFndaUser = {};
  isCollapsed = false;
  count;
  dot = true;
  @Output() handleCollapsed = new EventEmitter<boolean>();
  title: string;

  newMessage = [
    { author: 'molly', message: 'you are welcome' },
    { author: 'molly', message: 'you are welcome' },
    { author: 'molly', message: 'you are welcome' },
  ];
  oldMessage = [
    { author: 'WiGPS', message: 'you are welcome' },
    { author: 'WiGPS', message: 'you are welcome' },
    { author: 'WiGPS', message: 'you are welcome' },
  ];
  //langue: any;
  eventdata: any;
  selectLangue: any;
  window: any;
  languageItems;
  PersonInfoItems;
  subscription: Subscription;
  DownLoadFlag: string;
  Intranetdsata: any;
  crumbs: any;
  ActivatedRoute: any;
  public minuter: any;
  public hour: any;
  public second: any;
  private flag: boolean = true;//控制计计时变量
  public time: number;
  public timeid: any;
  SystemTimezone: any;
  shouldUpdateBreadcrumb: boolean = true;
  url: any;
  breadcrumbLabels: string[] = [];
  private pollingSubscription: Subscription;
  private previousLang: string;
  currentLang: 'zh-CN' | 'zh-TW' | 'en' | 'VN' = 'zh-TW';
  isAllowAdminSwitch = false; //是否有權限Switch
  isAdminSwitchedUser = false;
  private switchedTokenTimerSub!: Subscription; FIXED_BREADCRUMBS = [
    'platformTitle'
  ];
  switchedTokenRemaining: number | null = null; //SwitchedToken过期剩余時間,單位毫秒
  showIdentitySwitch = false;
  constructor(
    private fb: FormBuilder,
    private auth: AuthService,
    public titleSevice: GetTitleService,
    private translateService: TranslateService,
    private ConfigService: AppConfigService,
    private titleService: Title,
    private Environment: EnvironmentconfigService,
    private EnvironmentconfigService: EnvironmentconfigService,
    private WebApiService: WebApiService,
    private NzMessageService: NzMessageService,
    private matomoTracker: MatomoTracker,
    private translate: TranslateService,
    private webApiService: WebApiService,
    private LayoutComponent: LayoutComponent,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private i18: I18nService,
    private i18n: NzI18nService,
    private modalService: NzModalService

  ) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.resetBreadcrumbLabels();
      }
    });
    this.translate.onLangChange.subscribe((params) => {
    });
  }


  ngOnInit(): void {
    this.setCanAdminSwitch();
    this.setCanIdentitySwitch();
    this.setSwitchedUserTokenRemaining();
    this.isAdminSwitchedUser = this.auth.getSwitchedToken() ? true : false;
    this.userInfo = this.auth.getCurrentUserInfo();

    this.languageItems = this.ConfigService.getActualConfig('language');
    const offset = -new Date().getTimezoneOffset() / 60;
    const sign = offset >= 0 ? '+' : '-';
    this.SystemTimezone = `UTC${sign}${Math.abs(offset)}`;   //獲取user電腦時區
    // this.SystemTimezone = this.ConfigService.getActualConfig('SystemTimezone');
    // console.log('SystemTimezone' + this.SystemTimezone);

    this.PersonInfoItems = this.ConfigService.getActualConfig('PersonInfo');
    this.getLangLabel();
    this.switLanguage(this.selectLangue);
    //grt title data
    this.titleSevice.title$.subscribe((title) => {
      this.title = title;
    });
    // this.count=this.newMessage.length;
    this.oldMessage = this.newMessage.concat(this.oldMessage);
    //end get title data
    //matomo 点击率

    this.matomoTracker.setUserId(this.userInfo.siteNo + '-' + this.userInfo.englishName + '-' + this.userInfo.userId);
    this.matomoTracker.setCustomVariable(1, "UserName", this.userInfo.englishName, 'visit');
    this.matomoTracker.trackPageView();

    const storedLanguage = localStorage.getItem('wmsmlang');
    const defaultLanguage = 'zh-TW'; // 默认语言

    if (storedLanguage) {
      this.translateService.use(storedLanguage); // 设置应用程序的当前语言
      switch (storedLanguage) {
        case 'zh-TW':
          this.i18n.setLocale(zh_TW); // 设置 ng-zorro-antd 的当前语言为繁体中文
          break;
        case 'en':
          this.i18n.setLocale(en_US); // 设置 ng-zorro-antd 的当前语言为英文
          break;
        case 'zh-CN':
          this.i18n.setLocale(zh_CN); // 设置 ng-zorro-antd 的当前语言为中文
          break;
        case 'zh-CN':
          this.i18n.setLocale(zh_CN); // 设置 ng-zorro-antd 的当前语言为中文
          break;
        case 'VN':
          this.i18n.setLocale(vi_VN); // 设置 ng-zorro-antd 的当前语言为越南
          break;
        // 可以添加其他语言的设置逻辑
        default:
          this.i18n.setLocale(zh_TW); // 如果在 switch/case 中没有匹配到预期的语言值，则将 ng-zorro-antd 的当前语言设置为默认值（null）
      }
    } else {
      this.translateService.use(defaultLanguage);
    }
    this.pollingSubscription = interval(1000).subscribe(() => {
      this.checkForLanguageChange();
    });
  }
  async setCanAdminSwitch() {
    this.isAllowAdminSwitch = false;
    const adLoginUser = this.auth.getADLoginUser();
    const url = `${this.EnvironmentconfigService.authConfig.MVMBackEnd}${URLConst.GetUserGroupByUser.url}${adLoginUser.userId}`;
    const apiRes = await this.webApiService.doGet(url).toPromise() as TResult<JsFndaUserGroup[]>;
    if (apiRes.rc === 0 && apiRes.data?.length > 0) {
      //99是允许IT Switch的群組
      if (apiRes.data.some(x => x.userGroupId === 99)) {
        this.isAllowAdminSwitch = true;
      }
    }

    if (!this.isAllowAdminSwitch) {
      this.auth.clearSwitched();
    }
  }
  adminSwitchUser() {
    // 打开 SwitchDialogComponent 对话框
    const modalRef = this.modalService.create({
      nzTitle: this.translate.instant('SwitchAccount'),
      nzContent: SwitchDialogComponent,
      // 添加底部按钮
      nzFooter: [
        {
          label: this.translate.instant('cancel'),
          onClick: () => {
            modalRef.close();
          },
          nzDanger: true
        },
        {
          label: this.translate.instant('Ok'),
          onClick: () => {
            // 获取子组件实例
            const instance = modalRef.getContentComponent();
            if (instance && instance.getSelectedData) {
              // 调用子组件的方法获取选择的数据
              const switchedUser = instance.getSelectedData() as JsFndaUser;
              if (!switchedUser) {
                this.NzMessageService.error('Please select an account to switch.');
                return;
              }
              const targetEmail = switchedUser.email ?? '';
              if (!targetEmail) {
                this.NzMessageService.error('No email found for the selected employee.');
                return;
              }
              if (targetEmail.toUpperCase() === this.auth.getCurrentUserInfo()?.email?.toUpperCase()) {
                this.NzMessageService.warning('You cannot switch to your own account.');
                return;
              }
              const url = `${this.EnvironmentconfigService.authConfig.MVMBackEnd}${URLConst.AdminSwitchUser.url}`;
              this.NzMessageService.loading('Generating switched user info, please wait...', { nzDuration: 0 });
              setTimeout(() => {
                this.webApiService.doPost(url, {
                  targetUserEmail: targetEmail, userType: switchedUser.userType,
                  lang: localStorage.getItem('wmsmlang')
                }, false, true).subscribe(switchRes => {
                  if (switchRes.rc === 0 && switchRes.data) {
                    sessionStorage.removeItem('hasNoticedSwitchedUserTokenExpired');
                    this.auth.setSwitched(switchRes.data, switchedUser);
                    this.auth.clearMenu();
                    window.location.href = 'login/callback';
                  } else {
                    this.NzMessageService.remove();
                    this.NzMessageService.error('Generate switched user token error: ' + switchRes.msg);
                  }
                });
              }, 3000);
            }
            modalRef.close();
          }, type: 'primary'
        }
      ]
    });

  }
  existAdminSwitch() {
    this.auth.clearSwitched();
    this.auth.clearMenu();
    this.NzMessageService.loading('Exiting switched user, please wait...', { nzDuration: 3000 }).onClose.subscribe(() => {
      //導到callback, callback會自動刷新menu
      window.location.href = 'login/callback';
    });
  }
  async setSwitchedUserTokenRemaining() {
    const switchedUser = this.auth.getSwitchedToken();
    if (switchedUser) {
      const exp = this.auth.getSwitchedTokenExpiration();
      if (exp) {
        this.switchedTokenTimerSub?.unsubscribe();
        this.switchedTokenRemaining = this.auth.calculateSwitchedTokenRemaining(exp) * 1000;
        // 每秒更新一次
        this.switchedTokenTimerSub = interval(1000).subscribe(() => {
          this.switchedTokenRemaining = this.auth.calculateSwitchedTokenRemaining(exp) * 1000;
          //剩餘5分鐘時跳出提醒
          if (this.switchedTokenRemaining <= this.EnvironmentconfigService.authConfig.switchTokenExpireNotification * 60 * 1000) {
            const hasNoticed = sessionStorage.getItem('hasNoticedSwitchedUserTokenExpired');
            if (!hasNoticed) {
              this.NzMessageService.warning(
                `Switched user token is about to expire.<br>Please note whether it is necessary to switch the user again to extend the expiration time.`, { nzDuration: 10000 }
              );
              sessionStorage.setItem('hasNoticedSwitchedUserTokenExpired', 'true');
            }
          }
          if (this.switchedTokenRemaining <= 0) {
            this.switchedTokenRemaining = null;
            this.switchedTokenTimerSub?.unsubscribe();
            this.existAdminSwitch();
          }
        });
      }
    }
  };
  setCanIdentitySwitch() {
    this.showIdentitySwitch = false;
    const url = `${this.EnvironmentconfigService.authConfig.MVMBackEnd}${URLConst.GetMultiIdentity.url}`;
    this.webApiService.doGet(url).subscribe(res => {
      const result = res as TResult<JsFndaUser[]>;
      if (res.rc !== 0) {
        this.NzMessageService.error('Get multi-identity info error: ' + res.msg);
        console.error('Get multi-identity info error: ' + res.msg);
      } else {
        this.showIdentitySwitch = result.data && result.data.length > 1;
      }
    });
  }
  identitySwitch() {
    const modalRef = this.modalService.create({
      nzTitle: this.translate.instant('SwitchIdentities'),
      nzContent: SwitchIdentityComponent,
      // 添加底部按钮
      nzFooter: [
        {
          label: this.translate.instant('cancel'),
          onClick: () => {
            modalRef.close();
          },
          nzDanger: true
        },
        {
          label: this.translate.instant('Ok'),
          onClick: () => {
            // 获取子组件实例
            const instance = modalRef.getContentComponent();
            if (instance && instance.getSelectedData) {
              // 调用子组件的方法获取选择的数据
              const selectedUser = instance.getSelectedData() as JsFndaUser;
              if (!selectedUser) {
                this.NzMessageService.error('Please select an account to switch.');
                return;
              }
              const targetEmail = selectedUser.email ?? '';
              if (!targetEmail) {
                this.NzMessageService.error('No email found for the selected employee.');
                return;
              }

              //selectedUser會攜帶UserType(User/Vendor/GuestVendor/Customer/GuestCustomer)
              if (this.auth.getSwitchedToken()) {
                this.auth.setSwitched(this.auth.getSwitchedToken()!, selectedUser);
              } else {
                this.auth.setLoginUser(selectedUser);
              }
              this.auth.clearMenu();
              this.NzMessageService.loading('Generating switched identity info, please wait...', { nzDuration: 3000 })
                .onClose.subscribe(() => {
                  //設置一個標記讓其他tab頁面也能感知到身份切換從而刷新menu
                  localStorage.setItem('IdentitySwitchFlag', new Date().getTime().toString());
                  window.location.href = 'login/callback';//導到callback, callback會自動刷新身份
                });
            }
            modalRef.close();
          }, type: 'primary'
        }
      ]
    });
  }
  checkForLanguageChange() {
    const currentLang = sessionStorage.getItem('wmsmlang');
    if (currentLang !== this.previousLang) {
      this.previousLang = currentLang;
      this.onLanguageChange(currentLang);
    }
  }

  onLanguageChange(newLang: any) {
    this.currentLang = newLang;
    // 清空当前面包屑标签列表
    this.breadcrumbLabels = [];
    // 强制重新加载面包屑（此处假设面包屑组件和 `translateFn` 方法会重新被调用）
    this.breadcrumbLabels = this.createBreadcrumbs(this.activatedRoute.root);

  }

  createBreadcrumbs(route: ActivatedRoute, url: string = '', breadcrumbs: string[] = []): string[] {
    const children: ActivatedRoute[] = route.children;

    if (children.length === 0) {
      return breadcrumbs;
    }

    for (const child of children) {
      if (child.snapshot.data['breadcrumbStr']) {
        const routeURL: string = child.snapshot.url.map(segment => segment.path).join('/');
        url += `/${routeURL}`;
        const translatedLabel = this.translateService.instant(child.snapshot.data['breadcrumbStr']);
        breadcrumbs.push(translatedLabel);
      }
      return this.createBreadcrumbs(child, url, breadcrumbs);
    }

    return breadcrumbs;
  }


  toggleCollapsed(): void {
    this.isCollapsed = !this.isCollapsed;
    this.handleCollapsed.emit(this.isCollapsed);
  }
  logout() {
    this.auth.logoutAndClearAll();
  }

  // 切换语言
  switLanguage(languevalue: string): void {
    let localeConfig;

    switch (languevalue) {
      case 'zh-TW':
        localeConfig = zh_TW;
        break;
      case 'en':
        localeConfig = en_US;
        break;
      case 'zh-CN':
        localeConfig = zh_CN;
        break;
      case 'VN':
        localeConfig = vi_VN;
        registerLocaleData(vi);
        break;
      default:
        console.warn(`Unsupported language: ${languevalue}. Falling back to default language.`);
        localeConfig = zh_TW;
    }

    if (localeConfig) {
      try {
        // Set i18n locale
        this.i18n.setLocale(localeConfig);

        // Setting LocalStorage and SessionStorage
        localStorage.setItem("wmsmlang", languevalue);
        sessionStorage.setItem("wmsmlang", localStorage.getItem("wmsmlang"));

        // Set TranslateService language
        this.translateService.use(languevalue);

        // Set the title
        if (['en', 'zh-CN', 'zh-TW'].includes(languevalue)) {
          this.title = 'MVM';
        }
        this.titleService.setTitle(this.title);

        // Call other necessary method
        this.LayoutComponent.getannouncement();
      } catch (error) {
        console.error('An error occurred while setting language:', error);
      }
    } else {
      console.error('Failed to set locale: localeConfig is null or undefined');
    }
  }

  private readonly supportedLangs = ['zh-TW', 'zh-CN', 'en', 'VN'];

  private getBrowserPreferredLang(): string {
    const browserLang = navigator.language;
    if (browserLang) {
      if (this.supportedLangs.includes(browserLang)) {
        return browserLang;
      }
      const langPrefix = browserLang.split('-')[0];
      if (langPrefix === 'zh') {
        return browserLang.toLowerCase().includes('cn') ? 'zh-CN' : 'zh-TW';
      }
      if (langPrefix === 'en') {
        return 'en';
      }
      if (langPrefix === 'vi') {
        return 'VN';
      }
    }
    return 'zh-TW';
  }

  getLangLabel() {
    let langValue = localStorage.getItem("wmsmlang");
    if (!langValue || langValue === "undefined") {
      langValue = this.getBrowserPreferredLang();
      localStorage.setItem("wmsmlang", langValue);
    }
    // 同步到 sessionStorage
    sessionStorage.setItem("wmsmlang", langValue);

    // 设置 userInfo.lang
    this.userInfo.lang = langValue;
    if (this.auth.getSwitchedToken()) {
      this.auth.setSwitched(this.auth.getSwitchedToken()!, this.userInfo);
    } else {
      this.auth.setLoginUser(this.userInfo);
    }

    // 查找语言项
    const lang = this.languageItems.find(item => item.value === langValue);
    if (lang) {
      this.selectLangue = lang.value;
      this.userInfo.lang = lang.value;
      if (this.auth.getSwitchedToken()) {
        this.auth.setSwitched(this.auth.getSwitchedToken()!, this.userInfo);
      } else {
        this.auth.setLoginUser(this.userInfo);
      }
    }
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  RemoveCache(): void {
    const params = '';
    const url = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.RemoveCache.url}`;
    this.WebApiService.doGet(url, params).subscribe(
      (res) => {

      },
      (error) => this.NzMessageService.error(error.msg)
    );
  }


  translateFn = (key: string) => {
    if (!key) {
      return null;
    }
    this.breadcrumbLabels.push(this.translateService.instant(key));

  };


  resetBreadcrumbLabels() {
    this.breadcrumbLabels = [];
  }

  updateBreadcrumbLabels(label: string) {
    // 清空现有面包屑标签，避免重复
    this.breadcrumbLabels = [];
    // 进行更新操作
    this.breadcrumbLabels.push(label);
  }

  showAccountInfo() {
    this.modalService.create({
      nzContent: AccountInfoComponent,
      nzTitle: this.translate.instant('AccountInformation'),
      nzCancelText: null,
      nzWidth: '780px'
    });
  }
  showHelpInfo() {
    this.modalService.create({
      nzContent: HelpInfoComponent,
      nzTitle: this.translate.instant('HelpCenter'),
      nzFooter: null,
      nzWidth: '80vw',
      nzBodyStyle: {
        maxHeight: '70vh',
        overflow: 'auto'
      }
    });
  }
}



